<template>
  <v-layout wrap class="mx-3 mt-2 list-section">
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex xs12 sm12>
          <v-spacer></v-spacer>
          <v-btn dark small right class="red right" to="/tickets">
            <v-icon left>close</v-icon>Close
          </v-btn>
        </v-flex>
        <v-flex xs12 sm12 v-if="ticketError != ''" class="mb-2">
          <span
            style="color: #b71c1c;"
          >{{ ticketError }}</span>
        </v-flex>
        <v-flex xs12 sm12>
          <v-text-field
            v-validate="'required'"
            :error-messages="errors.collect('subject')"
            data-vv-name="subject"
            v-model="ticket.subject"
            label="Subject"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm12>
          <label>Description</label>
          <tinymce 
            id="description"
            data-vv-name="description"
            v-model="ticket.description"
            label="Description"
            :other_options="tinyOptions"
          ></tinymce>
        </v-flex>

        <v-flex xs12 class="text-xs-center text-md-right">
          <v-btn class="primary" dark @click="save">
            <v-icon left>save</v-icon> Submit
          </v-btn>
        </v-flex>
        
      </v-layout>
    </v-container>
    <!-- snackbar -->
    <snackbar ref="mySnackbar"></snackbar>
    <!-- end of snackbar -->
  </v-layout>
</template>

<script>
import Snackbar from "@/components/global/snackbar.vue";
import { mapGetters } from "vuex";
import tinymce from 'vue-tinymce-editor';
export default {
  name: "TicketsEditor",
  props: {
    initial: {
      type: Object,
      default: {}
    },
    editStatus: {
      type: String,
      default: "newRecord"
    },
    ticketError: {
      type: String,
      default: ''
    }
  },
  components: {
    Snackbar,
    tinymce
  },
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters(["host"])
  },
  data() {
    return {
      ticket: {},
      subject: null,
      description: null,
      editing: null,
      tinyOptions: {
        menubar:false,
        toolbar1:"formatselect | bold italic underline strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify | numlist bullist | removeformat",
        branding: false
      }
    };
  },
  watch: {
    initial: {
      handler: "setTicket",
      immediate: true
    },
    editStatus: {
      handler: "setStatus",
      immediate: true
    }
  },
  methods: {
    setTicket(val) {
      const ticket = this.ticket;
      this.ticket = { ...ticket, ...val};
    },
    setStatus(val) {
      this.editing = val;
    },
    save() {
      const self = this;
      this.$validator.validateAll().then(isValid => {
        if (isValid) {          
          if(this.ticket.subject == undefined || this.ticket.subject == null || this.ticket.subject.length == 0){
            this.$refs.mySnackbar.show("Please enter ticket subject", "red");
          } else if(this.ticket.description == undefined || this.ticket.description == null || this.ticket.description.length == 0){
            this.$refs.mySnackbar.show("Please enter ticket description", "red");
          } else{
            const data = {
              userId: this.user._id,
              subject: this.ticket.subject,
              description: this.ticket.description,
            };
            const formData = new FormData();

            if (this.editStatus == "editing") {
              formData.append("options", JSON.stringify(data));
              const details = { formData: formData, id: self.ticket._id };
              this.$emit("edata", details);
            } else {
              formData.append("data", JSON.stringify(data));
              this.$emit("data", formData);
            }
          }
        }
      });
    }
  },
  created() {
    this.ticket = {};
  }
};
</script>

